import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { StartGamePage } from '../pages//start-game/start-game';
import { JoinGamePage } from '../pages/join-game/join-game';
import { ChooseOpponentPage } from '../pages/choose-opponent/choose-opponent';
import { SelectQuestionPage } from '../pages/select-question/select-question';
import { SelectAnswerPage } from '../pages/select-answer/select-answer';
import { ResponseResultPage } from '../pages/response-result/response-result';
import { QuizResultPage } from '../pages/quiz-result/quiz-result';
import { WaitingPage } from '../pages/waiting/waiting';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DataProvider } from '../providers/data/data';
import { HttpModule } from '@angular/http';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    StartGamePage,
    JoinGamePage,
    ChooseOpponentPage,
    SelectQuestionPage,
    SelectAnswerPage,
    ResponseResultPage,
    QuizResultPage,
    WaitingPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/waiting/waiting.module#WaitingPageModule', name: 'WaitingPage', segment: 'waiting', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/choose-opponent/choose-opponent.module#ChooseOpponentPageModule', name: 'ChooseOpponentPage', segment: 'choose-opponent', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-question/select-question.module#SelectQuestionPageModule', name: 'SelectQuestionPage', segment: 'select-question', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-answer/select-answer.module#SelectAnswerPageModule', name: 'SelectAnswerPage', segment: 'select-answer', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/quiz-result/quiz-result.module#QuizResultPageModule', name: 'QuizResultPage', segment: 'quiz-result', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/response-result/response-result.module#ResponseResultPageModule', name: 'ResponseResultPage', segment: 'response-result', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/start-game/start-game.module#StartGamePageModule', name: 'StartGamePage', segment: 'start-game', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/join-game/join-game.module#JoinGamePageModule', name: 'JoinGamePage', segment: 'join-game', priority: 'low', defaultHistory: [] }
  ]
})
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    StartGamePage,
    JoinGamePage,
    ChooseOpponentPage,
    SelectQuestionPage,
    SelectAnswerPage,
    ResponseResultPage,
    QuizResultPage,
    WaitingPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts